// 所属校はアクティブな所属のみを含む groups クレームから判定する（groups_claim.js が付与）
export const GROUPS_CLAIM = 'https://auth.zenid.jp/groups';
// 在籍中の学籍番号クレーム（高校custom_scope.js が付与。卒業・退学後は null）
export const STUDENT_NUMBER_CLAIM = 'https://auth.zenid.jp/kddw-edu/highschool/student-number';
// 校内メールアドレスクレーム（高校custom_scope.js が付与。高校membershipのprofileのschoolEmail由来）
export const SCHOOL_EMAIL_CLAIM = 'https://auth.zenid.jp/kddw-edu/highschool/school-email';
export const EMAIL_CLAIM = 'email';

// 認可リクエストで要求する highschool スコープ（student-number クレームの付与条件）
export const HIGHSCHOOL_SCOPE = 'https://auth.zenid.jp/kddw-edu/highschool';

// groups クレーム値 "<組織名>:<ロール名>" の組織名に付く高校の接頭辞
export const HIGHSCHOOL_GROUP_PREFIX = 'kddw-edu/';

// 高校短縮名 → 所属校表示名（PDF 表記の短縮名）
export const SCHOOL_DISPLAY_NAMES = {
  'n-highschool': 'N高等学校',
  's-highschool': 'S高等学校',
  'r-highschool': 'R高等学校',
} as const;
export type HighschoolKey = keyof typeof SCHOOL_DISPLAY_NAMES;

// フッターリンク。terms/privacy は Auth0 サインアップ同意フォームと同じ公開URL、help は mypage-web と同値。
export const LINKS = {
  terms: 'https://zenid.jp/terms',
  privacy: 'https://dwango.co.jp/terms/privacy',
  help: 'https://help.zenid.jp/hc/ja',
  // 暫定: お問い合わせ専用URLが未定のため、暫定的にヘルプセンター(help)へ集約している。確定次第差し替える。
  contact: 'https://help.zenid.jp/hc/ja',
  // ログインに関する困りごとの案内先。角川ドワンゴ学園提供のテクニカルサポートサイト。
  technicalSupport: 'https://sites.google.com/nnn.ac.jp/technical-support/zenid',
} as const;
